// extracted by mini-css-extract-plugin
export var container = "_a3-0";
export var error = "_a3-9";
export var label = "_a3-5";
export var light = "_a3-6";
export var md = "_a3-3";
export var sm = "_a3-2";
export var thin = "_a3-8";
export var thinBold = "_a3-7";
export var vertical = "_a3-4";
export var xs = "_a3-1";